import { useMemo } from 'react';

import type { NestedAttachmentResponse } from '../openapi/types';
import { QUERY_STATE } from '../constants';

export const useAttachments = (attachments: NestedAttachmentResponse[]) => {
  return useMemo(() => {
    if (!attachments?.length) {
      return { regular: [], isdmvs: [] };
    }

    const isdmvs: (NestedAttachmentResponse & { deleteQueryState?: QUERY_STATE })[] = [];
    const regular: (NestedAttachmentResponse & { deleteQueryState?: QUERY_STATE })[] = [];
    attachments.forEach((attachment) => {
      switch (attachment.attachment_type) {
        case 'ROZSAH_EDITACE':
        case 'DVOJICE_IDENTIFIKATORU': {
          isdmvs.push(attachment);
          break;
        }
        default: {
          regular.push(attachment);
          break;
        }
      }
    });
    return { regular, isdmvs };
  }, [attachments]);
};
